var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_723_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7262 0H11.2738C5.3236 0 0.5 4.8236 0.5 10.7738V37.2262C0.5 43.1764 5.3236 48 11.2738 48H37.7262C43.6764 48 48.5 43.1764 48.5 37.2262V10.7738C48.5 4.8236 43.6764 0 37.7262 0Z",
    fill: "#0B86CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8011 19.9516H18.789V36.0458H13.8011V19.9516ZM16.3449 11.9543C16.9164 11.9544 17.475 12.1236 17.9504 12.4408C18.4258 12.7579 18.7966 13.2088 19.016 13.7364C19.2355 14.2641 19.2937 14.8449 19.1835 15.4056C19.0732 15.9663 18.7993 16.4818 18.3964 16.8871C17.9934 17.2923 17.4795 17.5692 16.9194 17.6827C16.3594 17.7961 15.7782 17.7412 15.2493 17.5248C14.7204 17.3084 14.2674 16.9402 13.9476 16.4666C13.6277 15.9931 13.4552 15.4354 13.452 14.8639C13.4498 14.4826 13.523 14.1047 13.6674 13.7517C13.8118 13.3988 14.0245 13.0779 14.2934 12.8075C14.5622 12.5371 14.8819 12.3226 15.234 12.1761C15.5861 12.0297 15.9636 11.9543 16.3449 11.9543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9812 19.9514H26.7862V22.1461C27.2672 21.3252 27.962 20.6504 28.7966 20.1936C29.6311 19.7368 30.574 19.5152 31.5247 19.5524C36.5126 19.5524 37.5268 22.8776 37.5268 27.2171V36.0456H32.5389V28.2645C32.5389 26.4024 32.5389 23.9916 29.9452 23.9916C27.3515 23.9916 26.9525 26.02 26.9525 28.1149V36.0789H21.9646L21.9812 19.9514Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_723_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.19a0d5f2d1bc34db72ac0426895ec160.svg";
export { ForwardRef as ReactComponent };